<div class="card card-body mb-0">
  <h5 class="mb-3 border-bottom">{{"DASHBOARD.Dodaj komitenta" | translate }}</h5>
  <form [formGroup]="clientForm" (ngSubmit)="onSubmit()">
     <div class="common-form row g-3">
      <div class="col-6 mb-2">
        <label class="fw-bold">{{ "PROPERTIES.Komitent" | translate }}</label>
        <input class="form-control" type="text" formControlName="komitent" />
        <ng-container [ngTemplateOutlet]="formError" [ngTemplateOutletContext]="{
            validation: 'required',
            message: 'VALIDATORS.PoljeNeSmijeBitiPrazno',
            control: this.clientForm.controls.komitent
          }">
        </ng-container>
      </div>
      <div class="col-6">
        <label class="fw-bold">{{ "PROPERTIES.Identifikacioni broj" | translate }}</label>
        <input class="form-control" maxlength="13" type="text" formControlName="identifikacioniBroj" inputmode="numeric"
          placeholder="" />
        <div class="d-flex flex-column">
          <ng-container [ngTemplateOutlet]="formError" [ngTemplateOutletContext]="{
              validation: 'required',
              message: 'VALIDATORS.PoljeNeSmijeBitiPrazno',
              control: this.clientForm.controls.identifikacioniBroj
            }">
          </ng-container>
          <ng-container [ngTemplateOutlet]="formError" [ngTemplateOutletContext]="{
              validation: 'isExactLength',
              message: 'VALIDATORS.IDBroj13Znamenki',
              control: this.clientForm.controls.identifikacioniBroj
            }">
          </ng-container>
        </div>
      </div>
      <div class="col-6">
        <label class="fw-bold">{{ "PROPERTIES.PDVBroj" | translate }}</label>
        <input class="form-control" type="text" formControlName="pdvBroj" inputmode="numeric" maxlength="12" />
        <ng-container [ngTemplateOutlet]="formError" [ngTemplateOutletContext]="{
            validation: 'isVATNumberExactLength',
            message: 'VALIDATORS.PDVBroj12Znamenki',
            control: this.clientForm.controls.pdvBroj
          }">
        </ng-container>
      </div>
      <div class="col-md-6 form-group">
        <label class="fw-bold">{{ "PROPERTIES.Grad" | translate }}</label>
        <div class="input-group">
          <ng-select [items]="cities" class="col p-0 form-select" loadingText="Ucitavanje..." [virtualScroll]="true"
            bindLabel="lookupString" bindValue="sifra" formControlName="grad" [selectOnTab]="true">
            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
              <div>{{ item.lookupString }}</div>
              <!--<div class="text-muted small">JIB: {{item.identifikacioniBroj}}</div>-->
            </ng-template>
          </ng-select>
          <button (click)="openAddNewCityModal()" type="button" class="btn btn-primary">
            <i class="fa fa-plus"></i>
          </button>
        </div>

        <ng-container [ngTemplateOutlet]="formError" [ngTemplateOutletContext]="{
            validation: 'required',
            message: 'VALIDATORS.PoljeNeSmijeBitiPrazno',
            control: this.clientForm.controls.grad
          }">
        </ng-container>


      </div>
      <div class="col-12">
        <label class="fw-bold">{{ "PROPERTIES.Adresa" | translate }} </label>
        <input class="form-control" type="text" formControlName="adresa" />
        <ng-container [ngTemplateOutlet]="formError" [ngTemplateOutletContext]="{
            validation: 'required',
            message: 'VALIDATORS.PoljeNeSmijeBitiPrazno',
            control: this.clientForm.controls.adresa
          }">
        </ng-container>
      </div>

      <div class="col-6">
        <label class="fw-bold">
          <span class="">{{ "PROPERTIES.Telefon" | translate }}</span>
          <app-tooltip key="invoice.date"></app-tooltip>
        </label>
        <input formControlName="telefon" class="form-control" type="email" />
      </div>

      <div class="col-6">
        <label class="fw-bold">
          <span class="">{{ "PROPERTIES.Email" | translate }}</span>
          <app-tooltip key="invoice.date"></app-tooltip>
        </label>
        <input formControlName="eMail" class="form-control" type="text" />

        <ng-container [ngTemplateOutlet]="formError" [ngTemplateOutletContext]="{
          validation: 'email',
          message: 'VALIDATORS.EmailFormat',
          control: this.clientForm.controls.eMail
        }">
        </ng-container>

        <div class="col12 mt-4 text-end">
          <button class="btn btn-light me-3" type="button" (click)="closeModal()">
            {{ "PROPERTIES.Otkazi" | translate }}
          </button>
          <button class="btn btn-primary" type="submit">
            {{ "PROPERTIES.SpremiIzmjene" | translate }}
          </button>
        </div>
      </div>
    </div>
  </form>
</div>

<ng-template #formError let-control="control" let-message="message" let-validation="validation">
  <ng-container *ngIf="control.hasError(validation) && control.touched">
    <small class="text-danger">{{ message | translate }}</small>
  </ng-container>
</ng-template>